module.exports = __webpack_public_path__ + "img/45f12bc57fb24290af9d4c7b662e84b801c9d22d.d9c1ff8d.png";